import React from 'react';
import { Card } from '../ui/card';
import InviteRow from './InviteRow';
import { useMyInvites } from './useMyInvites';
import './invitations.css';

export default function Invitations() {
  const { invites, loading, reloadInvites } = useMyInvites();

  if (invites.length === 0) return null;

  return (
    <Card title="Pending Invitations" className="dashboard-card">
      {loading && <p style={{ color: 'var(--clr-text-muted)' }}>Refreshing invitations...</p>}
      {invites.map(inv => (
        <InviteRow
          key={inv.id}
          invite={inv}
          onAction={reloadInvites}
        />
      ))}
    </Card>
  );
}
